<template>
  <div class="ret-cards-wrapper">
    <v-card class="ret-header-card">
      <v-card-title>
        <v-layout row>
          <v-flex xs6 md3>
            <v-text-field
              clearable
              hide-details
              solo
              v-model="search"
              :label="$t('search')"
              append-icon="search"
              data-test="search"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md3>
            <v-switch
              v-model="showArchived"
              input-value="true"
              :label="$t('archived')"
              class="mt-2"
              data-test="archived"
            ></v-switch>
          </v-flex>
          <v-flex grow class="text-right">
            <v-btn fab small dark
              @click="$router.push({ name: 'user-groups' })"
              :title="$t('user-groups')"
              class="mx-2"
              color="primary"
              data-test="user-groups"
            >
              <v-icon>perm_identity</v-icon>
            </v-btn>
            <v-btn fab small dark
              @click="$router.push({name: `${model.name}/new`})"
              :title="$t('users.new')"
              class="mx-2"
              color="accent"
              data-test="new-user"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>

    <v-card class="ret-card-new">
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="pagedItems"
          :server-items-length="totalItems"
          :no-data-text="$t('no-data-available')"
          :footer-props="{ 'items-per-page-text': $t('rows-per-page'), 'items-per-page-options': [10,20,50,100,{ text: $t('all'), value: -1 }] }"
          :options.sync="options"
          :loading="loading"
        >
          <template slot="item" slot-scope="props">
            <tr @click="showItemDetail(props.item)" :class="rowClass(props.item)">
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.firstname }}</td>
              <td>{{ props.item.lastname }}</td>
              <td>{{ props.item.email }}</td>
              <td v-if="props.item.archivedAt">
                <v-btn
                  text
                  icon
                  small
                  :title="$t('restore')"
                  @click.stop="restoreItem(props.item)"
                  data-test="restore"
                >
                  <v-icon>delete_forever</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import lazyItems from '../helpers/lazy-items.es6'

export default {
  mixins: [lazyItems],
  data () {
    return {
      model: {
        name: 'users',
        searchColumns: ['code', 'firstname', 'lastname', 'email']
      },
      options: {
        sortBy: ['lastname']
      },
      defaultHeaders: [
        { text: this.$t('code'), value: 'code', align: 'left' },
        { text: this.$t('first-name'), value: 'firstname' },
        { text: this.$t('last-name'), value: 'lastname' },
        { text: this.$t('email'), value: 'email' }
      ]
    }
  },
  methods: {
    rowClass (item) {
      const disabled = !this.$can('admin') && item.role === 'admin'
      return {
        disabled
      }
    }
  }
}
</script>

<style>
tr.disabled {
  color: #777;
  background-color: #efefef;
}
</style>
